import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CGUID, SyncSeekUrl, SyncPullSerializedUrl, GetDatasyncMediaOneBlockSynchronously,SyncDeleteSynchronously } from "datasync-core";
import { globals} from "../Components/Globals/Globals";
import {produce} from "immer"

const initialState = {
  hotelsItems: [],
  hotelCount: 0,
  loadHotels_result:{status: 'idle', error: null},
}

// Create an async thunk for loading hotels
export const loadHotels = createAsyncThunk(
  'hotels/loadHotels',
  async (thunkAPI) => {
    try {
      const response = await GetDatasyncMediaOneBlockSynchronously({
        session_guid: CGUID(),
        date_synchro: '1970-07-10 063050',
        company_guid: globals.datasync.h_immo_company_guid,
        datasync_url: globals.datasync_service.url,
        syncSeekUrl: SyncSeekUrl(globals.datasync_service.url),
        SyncPullSerializedGETurl: SyncPullSerializedUrl(globals.datasync_service.url),
        seek_filter_clause: ` data_blob like '%"validation":"Oui"%' `, // Display only validated hotels
        //seek_filter_clause: ` true `, // Display only validated hotels
        table_guid: globals.datasync.h_immo_hotels_table_guid,
        debugging: true
      });
      if (globals.parameters.debugging)
        console.log("loadHotels::hotels response = ",response)
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const hotelSlice = createSlice({
  name: 'hotels',
  initialState,
  reducers: {
    revertAll(state){
      console.log("hotelSlice revertAll");
      //state = initialState;
      //console.log("state.hotelCount ->",state.hotelCount)
      state.hotelCount = 0;
      state.hotelsItems = [];
      state.loadHotels_result = {status: 'idle', error: null};
    },

    revertStatus(state){
      if (globals.parameters.debugging)
        console.log("hotelSlice revertStatus")

      state.reassign_result = {status : "idle", error : null, hotel_name: null, user_action:null, user_guid_owner:null};
    }
  },
  extraReducers: (builder) => {
    builder
      /* loadHotels */
      .addCase(loadHotels.pending, (state, action) => {
        state.loadHotels_result = {status : "loading",error : null};
      })
      .addCase(loadHotels.fulfilled, (state, action) => {
        try {
          if (action.payload.length > 0) {
            state.loadHotels_result = {status : "succeeded",error : null};
            state.hotelsItems = action.payload;
            state.hotelCount= action.payload.length;
          }
          else{
            throw("None hotels returned !")
          }
        } catch (error) {
            console.error(`loadHotels.fulfilled raises -> ${error}`);
            state.loadHotels_result = {status : "succeeded",error : "No hotels found !!!"};
            state.hotelsItems = [];
            state.hotelCount= 0;
        }
      })
      .addCase(loadHotels.rejected, (state, action) => {
        if (globals.parameters.redux_debugging) alert("loadHotels.rejected")
          console.log("loadHotels.rejected -> action", action)
        state.loadHotels_result = {status : "failed",error : action.payload};
      })
  },
});

export const { addHotel, updateHotel, revertAll, revertStatus } = hotelSlice.actions;
export default hotelSlice.reducer;
